export default __webpack_public_path__ + "static/media/revista.96864aa5.png";